import { render } from "./np-buttons.vue?vue&type=template&id=283f2887"
import script from "./np-buttons.vue?vue&type=script&lang=js"
export * from "./np-buttons.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__